module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-400.501ce09c42716a2f6e1503a25eb174c9.woff2";